import { globalElements } from '../glob';
import { isFunction, isObject } from 'lodash';
import { isValidElement, cloneElement } from 'react';
import { allEvent } from './events';
import { genId } from './util';
const lifeCycleNames = ['created', 'attached', 'ready', 'detached', 'moved'];

// 筛选事件属性，一般属性，内联组件属性
export function filterProperties(params: any, uniqId: string): any {
  const events = {};
  const notEvents = {};
  const innerComponents = {};
  const lifeTimes = {};
  const $attr = params.attr || {};
  delete params.attr;
  Object.keys(params).forEach((ky: string) => {
    if (allEvent.indexOf(ky) > -1) {
      const val: () => void = params[ky];
      if (isFunction(val)) {
        let evtKey = ky;
        if (ky === 'tap' || ky === 'aim') {
          evtKey = 'onClick';
        }
        events[evtKey] = function (e) {
          if (ky === 'aim') {
            e.preventDefault();
            e.stopPropagation();
          }
          const instance = globalElements[uniqId];
          val(e, {}, instance);
        };
      }
    } else {
      const val: Partial<{uniqId: string; key: string}> = params[ky];
      if (ky.indexOf('@') === 0) {
        if (isObject(val) && !isValidElement(val)) {
          val.uniqId = val.uniqId || uniqId + '.' + genId(8);
          val.key = val.uniqId;
          innerComponents[ky] = val;
        }
      } else if (lifeCycleNames.indexOf(ky) > -1) {
        lifeTimes[ky] = val;
      } else {
        notEvents[ky] = val;
      }
    }
  });

  const attr = {};
  Object.keys($attr).forEach((ky: string) => {
    let val = $attr[ky];
    if (ky.indexOf('data-') === 0) {
      attr[ky] = val;
    } else {
      attr['data-' + ky] = val;
    }
  });

  // ? 内联组件 @list @item @tree @form @md
  return { events, notEvents, innerComponents, lifeTimes, attr };
}
